import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MechanicsService } from '../../_services/mechanics.service';

@Component({
	selector: 'doc-field-compact',
	templateUrl: './doc-field-compact.component.html',
	styleUrls: ['./doc-field-compact.component.css'],
	standalone: false
})
export class FieldCompactComponent {

	@Input() field: any;

	public isExpanded: boolean = false; // Togglable ellipsis in case of long text

	constructor(public ms: MechanicsService) { }

	get hasEllipsis() {
		return this.field.content && this.field.content.length > 1000
	}

}
